import { Trans } from "react-i18next";

export default function StageChangedContent({ ownerChallenge }) {
  return (
    <Trans
      i18nKey="notifications.stageChanged"
      values={{ challenge: ownerChallenge?.name || "Deleted" }}
    />
  );
}
